import script from "./ITicket.vue?vue&type=script&setup=true&lang=js"
export * from "./ITicket.vue?vue&type=script&setup=true&lang=js"

import "./ITicket.vue?vue&type=style&index=0&id=27c5d856&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c5d856"]])

export default __exports__